export default function (id) {
  return {
    imageSource: '',
    init() {
      fetch(`https://vimeo.com/api/v2/video/${id}.json`)
        .then((res) => res.json())
        .then((data) => {
          this.imageSource = data[0]?.thumbnail_large || '';
        })
        .catch((err) => {
          console.error(`Thumbnail error for ID ${id}:`, err);
        }); 
    }
  };
}
